var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as App from '../../app';
import * as effects from './src/animations';
import * as utils from '../../lib/utils';
import * as FEATURES from '../../app/const/features';
import { CanvasGame } from './CanvasGame';
import { drawData, drawGrid, drawPreview, drawSlices } from '../../components/Game/src/drawing';
import { alignSlices, calcCellSize, calcGridPos, calcSlicesRect } from '../../components/Game/src/geometry';
import { CUP_PATH } from '../../app/const/svg';
import { decodeData, safeDecodeSlices, encodeData, encodeSlices, today } from '../../app/storage';
import { getSlices, highlighting, initData, randomSlices, rotateData, sliceByPos, usefulHint } from '../../utils';
import { clearData, cloneData, cloneSlice, countChanges, findChanges } from '../../utils';
import { PHRASES, t } from '../../translate';
import { checkLoss, checkLossWithRotate, shadow } from '../../shadow';
import { hexToRgba } from '../../lib/MediumColor/hexToRgba';
import { SvgPath } from '../../lib/dom';
import { drawSmallScreenMsg, isSmallScreen } from './src/isSmallScreen';
import { GRID_SIZE } from '../../app/const/game';
import { Instructor } from '../Instructor/Instructor';
var isCancelMoveFeature = function () {
    if (FEATURES.CANCEL_MOVE_FEATURE) {
        return App.storage.get().cancelMove;
    }
    return false;
};
var cup = new SvgPath({
    viewBox: '0 0 40 42',
    path: [CUP_PATH],
    fill: App.themes.get().cell,
    width: 40,
    height: 42,
});
function normalizeValue(v) {
    return v ? Number(v) : 0;
}
var Game = /** @class */ (function (_super) {
    __extends(Game, _super);
    function Game(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Game';
        _this.data = FEATURES.BIN_FEATURE ? decodeData(App.storage.get().data) : App.storage.get().data;
        _this.slices = FEATURES.BIN_FEATURE
            ? safeDecodeSlices(App.storage.get().slices.slice(0))
            : App.storage.get().slices;
        _this.score = App.storage.get().score;
        _this.maxScore = App.storage.get().maxScore;
        _this.newDailyRecord = App.storage.get().score >= App.storage.get().maxScoreToday;
        _this.newTotalRecord = App.storage.get().score >= App.storage.get().maxScore;
        _this.isFirstGame = App.storage.get().maxScore === 0;
        _this.stopped = false;
        _this.dragStartTime = 0;
        _this.dragDropEnabled = true;
        _this.slice = null;
        _this.startPos = null;
        _this.dataBefore = null;
        _this.gameOver = false;
        _this.rotateCounter = 0;
        _this.seriesCounter = 0;
        _this.history = [];
        _this.cellSize = calcCellSize();
        _this.gridPos = calcGridPos(_this.cellSize);
        _this.scoreBuffer = 0;
        _this.instructor = null;
        // EVENTS
        _this.onResize = utils.throttle(function () {
            _super.prototype.onResize.call(_this);
            _this.cellSize = calcCellSize();
            _this.gridPos = calcGridPos(_this.cellSize);
            alignSlices(_this.slices);
        }, 33);
        _this.dragStart = function (e) {
            if (!_this.dragDropEnabled || _this.isTimerEffect()) {
                return;
            }
            if (e.target !== _this.scene.canvas && (!_this.instructor || e.target !== _this.instructor.getCanvas())) {
                return;
            }
            if (utils.isTouchDevice() && e.target.tagName !== 'SELECT') {
                e.preventDefault();
                e.target.click();
            }
            if (e.target.tagName !== 'CANVAS') {
                return;
            }
            _this.emitter.emit('dragStart', {});
            if (_this.slice || _this.gameOver) {
                return;
            }
            _this.dragStartTime = Date.now();
            var pos = utils.eventPos(e);
            var slice = sliceByPos(_this.slices, pos);
            if (slice && slice.hidden && slice.shadow && isCancelMoveFeature()) {
                _this.emitter.emit('cancelMove', { slice: slice });
                App.sounds.click();
                return;
            }
            if (slice && !slice.hidden) {
                _this.slice = slice;
                _this.startPos = pos;
                _this.dataBefore = cloneData(_this.data);
                _this.jumpTid = setTimeout(function () {
                    if (_this.slice) {
                        _this.selectSlice(_this.slice);
                        _this.needRedraw = true;
                    }
                }, 100);
            }
        };
        _this.dragMove = utils.throttle(function (e) {
            if (_this.startPos && _this.dataBefore && _this.slice && !_this.gameOver) {
                e.preventDefault();
                if (_this.jumpTid) {
                    clearTimeout(_this.jumpTid);
                }
                var pos = utils.eventPos(e);
                _this.slice.move = { x: pos.x - _this.startPos.x, y: pos.y - _this.startPos.y };
                if (Date.now() - _this.dragStartTime > 100) {
                    _this.selectSlice(_this.slice);
                }
                _this.needRedraw = true;
                var dataAfter = shadow(_this.slice, cloneData(_this.dataBefore));
                if (dataAfter) {
                    _this.data = highlighting(dataAfter);
                }
                else {
                    _this.data = _this.dataBefore;
                }
            }
        }, 33);
        _this.dragEnd = function (e) {
            if (_this.gameOver)
                return;
            if (!_this.slice) {
                var pos = utils.eventPos(e);
                var _a = _this.getCoupPos(), cx = _a[0], cy = _a[1];
                var dist = utils.getDistance(cx, cy - 25, pos.x, pos.y);
                if (dist < 25 && _this.useCoupBtn)
                    _this.emitter.emit('click-rating', {});
                return;
            }
            if (_this.jumpTid)
                clearTimeout(_this.jumpTid);
            if (FEATURES.USE_ROTATE && Date.now() - _this.dragStartTime < 400) {
                _this.slice.data = rotateData(_this.slice.data, _this.slice.gridSize);
                alignSlices(_this.slices);
                _this.rotateCounter++;
                if (_this.instructor)
                    _this.instructor.onRotate();
                _this.stopMove();
                _this.data = _this.data.map(function (item) { return (__assign(__assign({}, item), { shadow: 0 })); });
                App.sounds.rotate();
                return;
            }
            if (FEATURES.CANCEL_MOVE_FEATURE) {
                _this.slice.shadow = _this.getShadow();
            }
            var dataBefore = _this.data.slice(0);
            var dataAfter = dataBefore.map(function (i) { return (__assign(__assign({}, i), { shadow: 0, highlighting: false, value: normalizeValue(i.value || i.shadow) })); });
            var countAdded = countChanges(_this.dataBefore, dataAfter);
            _this.data = clearData(dataAfter);
            var deleted = findChanges(dataAfter, _this.data); // важно чтобы это было после clearData
            var countDeleted = deleted.length;
            var countStars = deleted.reduce(function (acc, i) { return (dataAfter[i].value === 2 ? 1 : 0) + acc; }, 0);
            updCurrentDate();
            if (countAdded) {
                _this.addScore(countAdded);
                _this.slice.hidden = true;
                if (_this.instructor)
                    _this.instructor.onDrop(countDeleted);
            }
            else {
                if (FEATURES.USE_ROTATE)
                    App.sounds.playSound(56790);
            }
            if (countDeleted) {
                _this.addScore(_this.deleteScore(countDeleted));
                deleted.forEach(function (i) {
                    if (FEATURES.CANCEL_MOVE_FEATURE) {
                        _this.slices.map(function (slice) {
                            if (slice.shadow && slice.shadow.includes(i)) {
                                slice.shadow = undefined;
                            }
                        });
                    }
                    return _this.addCellAnimation(i);
                });
                App.sounds.match();
            }
            else {
                if (countAdded)
                    App.sounds.playSound(40846);
            }
            _this.stopMove();
            _this.updateSlices();
            if (countStars === 0 || !FEATURES.FIGURINES_WITH_STARS) {
                _this.addScoreAnimations(e, countAdded, countDeleted);
            }
            if (countAdded && FEATURES.CANCEL_MOVES_FEATURE) {
                _this.updateMovesHistory();
            }
            if (_this.isGameOver()) {
                _this.gameOver = true;
                setTimeout(function () { return _this.onGameOver(_this.newDailyRecord, _this.newTotalRecord); }, 100);
            }
            _this.saveSate();
            if (countStars && FEATURES.FIGURINES_WITH_STARS) {
                var coins_1 = countStars * 10;
                _this.addCoinsEffect(coins_1).then(function () {
                    App.sounds.match();
                    _this.emitter.emit('star', { coins: coins_1 });
                });
            }
            _this.emitter.emit('move', { gameOver: _this.gameOver, countAdded: countAdded, countDeleted: countDeleted, countStars: countStars });
        };
        _this.sliceJumpY = function (slice) {
            if (slice && _this.startPos) {
                if (utils.isTouchDevice()) {
                    if (window.innerWidth > 500) {
                        return slice.pos.y - _this.startPos.y + 3 * _this.cellSize;
                    }
                    return slice.pos.y - _this.startPos.y + 4 * _this.cellSize;
                }
                else {
                    return _this.cellSize;
                }
            }
            return 0;
        };
        _this.sliceJumpX = function (_slice) {
            return _this.cellSize / 2;
        };
        if (!_this.data || !_this.data.length || !_this.slices || !_this.slices.length) {
            _this.data = initData(GRID_SIZE * GRID_SIZE);
            _this.slices = randomSlices();
            _this.score = 0;
        }
        _this.useCoupBtn = props.useCoupBtn !== undefined ? props.useCoupBtn : true;
        App.emitter.on('lang', function () { return _this.reDraw(); });
        utils.initDrag(_this.dragStart, _this.dragEnd, _this.dragMove);
        setTimeout(function () { return _this.onResize(); }, 250);
        if (DEVELOPMENT) {
            // @ts-ignore
            window['_alignSlices'] = function () {
                alignSlices(_this.slices);
                _this.needRedraw = true;
            };
            // @ts-ignore
            window['updateSlices'] = function () {
                _this.updateSlices(true);
                _this.needRedraw = true;
            };
            // @ts-ignore
            window['addCoinsEffect'] = function () {
                _this.addCoinsEffect(100);
            };
            if (location.search.includes('win')) {
                setTimeout(function () {
                    _this.data.forEach(function (i, index) { return (i.value = index > 0 ? 1 : 0); });
                    _this.score = 500 + Math.ceil(Math.random() * 1000);
                    _this.onGameOver(true, Math.random() > 0.5);
                }, 50);
            }
            if (location.search.includes('loss')) {
                setTimeout(function () { return _this.onGameOver(false, false); }, 50);
            }
            if (location.search.includes('slicesRect')) {
                var _a = calcSlicesRect(), x_1 = _a.x, y_1 = _a.y, w_1 = _a.w, h_1 = _a.h;
                setInterval(function () { return _this.scene.strokeRect(x_1, y_1, w_1, h_1, '#00f', 1); }, 100);
            }
            if (location.search.includes('confettiEffect')) {
                setTimeout(function () { return _this.addConfettiEffect(); }, 500);
            }
            // @ts-ignore
            window['addComboAnimation'] = function () {
                _this.addScoreAnimations({ pageX: 0, pageY: 100 }, 3, 12);
            };
            // @ts-ignore
            window['addSeriesAnimation'] = function () {
                _this.seriesCounter = 1;
                _this.addScoreAnimations({ pageX: 0, pageY: 100 }, 3, 9);
            };
            // @ts-ignore
            window['addScoreAnimation'] = function (x) {
                if (x === void 0) { x = utils.random(0, window.innerWidth); }
                _this.seriesCounter = 0;
                _this.addScoreAnimations({ pageX: x, pageY: utils.random(0, window.innerHeight) }, 3, 9);
            };
            // @ts-ignore
            window['addHighScoreEffect'] = function (absolute) {
                if (absolute === void 0) { absolute = false; }
                _this.addConfettiEffect(function () { return _this.emitter.emit('HighScore', { absolute: absolute, score: 0 }); });
                var score = utils.random(1000, 10000);
                _this.addHighScoreEffect(score, absolute);
                setTimeout(function () { return _this.pause(); }, 600);
                _this.score = score;
            };
            // @ts-ignore
            window['addCellAnimation'] = function () {
                _this.addCellAnimation(0).then(function (_) { });
                _this.addCellAnimation(9).then(function (_) { });
                _this.needRedraw = true;
            };
            if (location.search.includes('gameOver')) {
                setTimeout(function () {
                    _this.data.map(function (item, i) {
                        item.value = (i < 30 || (i > 32 && i < 39) || (i > 41 && i < 48) || i > 50) && i % 2 === 0 ? 1 : 0;
                    });
                    _this.slices = getSlices(6, 6, 6);
                    _this.needRedraw = true;
                }, 1);
            }
            var totalScore_1 = 0;
            var countGames_1 = 0;
            var botMove_1 = function () {
                var hint = usefulHint(_this.slices, _this.data);
                if (hint) {
                    _this.data = hint[0].map(function (i) { return ({ value: normalizeValue(i.value || i.shadow) }); });
                    hint[1].hidden = true;
                    _this.needRedraw = true;
                    var dataAfter = _this.data.map(function (i) { return ({ value: normalizeValue(i.value || i.shadow) }); });
                    _this.data = clearData(_this.data);
                    var countAdded = hint[1].data.filter(function (i) { return i.value; }).length;
                    var countDeleted = findChanges(dataAfter, _this.data).length;
                    _this.updateSlices();
                    _this.addScoreAnimations({ pageX: 100, pageY: 100 }, countAdded, countDeleted);
                    countAdded && _this.addScore(countAdded);
                    countDeleted && _this.addScore(_this.deleteScore(countDeleted));
                }
                else {
                    if (!_this.gameOver) {
                        countGames_1++;
                        totalScore_1 += _this.getScore();
                        var avgScore = Math.floor(totalScore_1 / countGames_1);
                        console.log("".concat(countGames_1, "; ").concat(avgScore));
                        _this.gameOver = true;
                        _this.needRedraw = true;
                        if (countGames_1 < 100)
                            setTimeout(function () {
                                _this.newGame();
                                playBot_1();
                            }, 500);
                    }
                }
            };
            var playBot_1 = function () {
                if (_this.gameOver)
                    return;
                botMove_1();
                setTimeout(function () { return playBot_1(); }, 1);
            };
            window.addEventListener('keyup', function (e) {
                if (e.key === 'b' && e.ctrlKey) {
                    if (_this.gameOver) {
                        _this.newGame();
                    }
                    playBot_1();
                }
                if (e.key === 'm' && e.ctrlKey) {
                    botMove_1();
                }
            });
            // @ts-ignore
            window['adTimerEffect'] = function () { return _this.adTimerEffect(); };
        }
        return _this;
    }
    Game.prototype.toggleCoupBtn = function (toggle) {
        this.useCoupBtn = toggle;
        this.needRedraw = true;
    };
    Game.prototype.addCoinsEffect = function (coins) {
        var x = this.scene.width / 2;
        var y = this.scene.height / 2;
        return this.promisifyEffect(effects.CoinsEffect, { coins: coins, x: x, y: y, x2: x, y2: 25 });
    };
    Game.prototype.learn = function (cb) {
        var _this = this;
        this.instructor = new Instructor(function (data, slices) {
            _this.data = data;
            _this.slices = slices;
            alignSlices(_this.slices);
            _this.needRedraw = true;
        }, function () { return ({ data: _this.data, slices: _this.slices }); }, function () {
            _this.instructor = null;
            App.sounds.click();
            cb();
            _this.isFirstGame = true;
        }, function () {
            var x = _this.gridPos.x + 50;
            var y = _this.gridPos.y + _this.cellSize * 11;
            _this.addScoreAnimation(t(PHRASES.Excellent), x, y, 20);
        });
    };
    Game.prototype.stopLearn = function () {
        if (this.instructor) {
            this.instructor.remove();
            this.instructor = null;
        }
    };
    Game.prototype.stop = function () {
        this.stopped = true;
    };
    Game.prototype.reDraw = function () {
        alignSlices(this.slices);
        this.needRedraw = true;
    };
    Game.prototype.newGame = function () {
        var _this = this;
        this.data.forEach(function (i, index) { return i.value && _this.addCellAnimation(index, 250); });
        this.data = initData(GRID_SIZE * GRID_SIZE);
        this.slices = randomSlices();
        alignSlices(this.slices);
        this.score = 0;
        this.needRedraw = true;
        this.gameOver = false;
        this.rotateCounter = 0;
        this.scoreBuffer = 0;
        this.seriesCounter = 0;
        this.history = [];
        this.dataBefore = null;
        this.newDailyRecord = false;
        this.newTotalRecord = false;
        this.isFirstGame = App.storage.get().maxScore === 0;
        this.saveSate();
    };
    Game.prototype.getMaxCounter = function () {
        return this.maxScore;
    };
    Game.prototype.setMaxCounter = function (count) {
        this.maxScore = Math.max(this.maxScore, count, App.storage.get().maxScore);
    };
    Game.prototype.showHint = function (cb) {
        var _this = this;
        var hint = usefulHint(this.slices, this.data);
        if (hint && !this.slice) {
            this.addHintEffect(hint[0], { direction: 1 }).then(function () {
                _this.addHintEffect(hint[0], { direction: -1, delay: 600, color: '#de9534' }).then(function () {
                    cb(true);
                });
            });
        }
        else {
            cb(false);
        }
    };
    Game.prototype.addHintEffect = function (hintData, props) {
        var _this = this;
        var promises = [];
        hintData.forEach(function (i, index) {
            if (i.shadow) {
                promises.push(_this.addCellAnimationByProps(index, props));
                // if (props.direction == -1) this.addSparkEffect(index)
            }
        });
        return Promise.all(promises);
    };
    Game.prototype.cancelMoves = function () {
        if (this.history.length) {
            this.data = cloneData(this.history[0].data);
            this.slices = cloneData(this.history[0].slices);
            this.score = this.history[0].score;
            this.history = [];
            this.slices.map(function (slice) {
                slice.selected = false;
                slice.move.x = 0;
                slice.move.y = 0;
            });
            alignSlices(this.slices);
            this.needRedraw = true;
            this.gameOver = false;
            this.saveSate();
            return true;
        }
        return false;
    };
    Game.prototype.getPreview = function () {
        return drawPreview(this.data, this.slices, 1, isCancelMoveFeature());
    };
    Game.prototype.isNoEmptyGameArea = function () {
        return this.data && this.data.reduce(function (acc, cur) { return Boolean(cur.value) || acc; }, false);
    };
    Game.prototype.saveSate = function () {
        if (this.gameOver) {
            App.storage.upd({
                data: FEATURES.BIN_FEATURE ? encodeData([]) : null,
                slices: FEATURES.BIN_FEATURE ? encodeSlices([]) : null,
                score: 0,
            });
        }
        else {
            App.storage.upd({
                data: FEATURES.BIN_FEATURE ? encodeData(this.data || []) : this.data,
                slices: FEATURES.BIN_FEATURE ? encodeSlices(this.slices || []) : this.slices,
                score: this.getScore(),
            });
        }
    };
    Game.prototype.toggleDragDrop = function (toggle) {
        this.dragDropEnabled = toggle;
    };
    // DRAWING
    Game.prototype.draw = function (_time, needRedraw) {
        if (isSmallScreen()) {
            drawSmallScreenMsg(this.scene, '#c0ddfc');
            return;
        }
        _super.prototype.draw.call(this, _time, needRedraw);
    };
    Game.prototype.drawBackground = function () {
        if (DEVELOPMENT && location.search.includes('promo')) {
            this.scene.fillAll('#CCFFFF');
        }
        else {
            var bg = App.themes.get().bg;
            this.scene.fillAll(bg);
        }
    };
    Game.prototype.drawScene = function () {
        drawGrid(this.scene, this.cellSize, this.gridPos);
        if (!this.stopped) {
            drawData(this.scene, this.data, this.cellSize, GRID_SIZE, this.gridPos);
            drawSlices(this.scene, this.slices, this.cellSize, 1, true, isCancelMoveFeature());
        }
        this.drawCounters();
    };
    Game.prototype.drawCounters = function () {
        var color = App.themes.get().counters;
        this.scene.fillStyle(IS_ULTRA ? '#2e4088' : color);
        var fontSize = Math.max(10, Math.ceil(this.cellSize * 0.35));
        this.scene.font(fontSize, 'Arial', 'bold');
        var y = this.gridPos.y - 7;
        this.drawScoreCounter(y);
        this.drawRecordScoreCounter(y, fontSize);
        if (this.useCoupBtn) {
            this.drawCoup.apply(this, __spreadArray(__spreadArray([], this.getCoupPos(), false), [Math.min(46, this.cellSize)], false));
        }
    };
    Game.prototype.drawScoreCounter = function (y) {
        this.scene.fillText("".concat(t(PHRASES.Score), ": ").concat(this.score), this.gridPos.x, y);
    };
    Game.prototype.drawRecordScoreCounter = function (y, fontSize) {
        var label = "".concat(t(PHRASES.All_time_record), ":");
        var value = App.Fn.getScoreString(App.storage.get().maxScore);
        var text = "".concat(label, " ").concat(value);
        var right = this.gridPos.x + GRID_SIZE * this.cellSize;
        if (this.scene.textWidth(text) > this.cellSize * 3.5) {
            var x1 = right - this.scene.textWidth(label);
            this.scene.fillText(label, x1, y - fontSize);
            var x2 = right - this.scene.textWidth(value);
            this.scene.fillText(value, x2, y);
        }
        else {
            var x = right - this.scene.textWidth(text);
            this.scene.fillText(text, x, y);
        }
    };
    Game.prototype.getCoupPos = function () {
        var y1 = this.gridPos.y - 7;
        return [this.scene.width / 2, y1];
    };
    Game.prototype.drawCoup = function (x, y, wh) {
        var _this = this;
        var COUP_COLOR = '#F1BD17';
        var image = cup.toImage(COUP_COLOR, function () { return _this.reDraw(); });
        if (image && image.complete && image.width && image.height) {
            this.scene.drawImage(image, 0, 0, image.width, image.height, x - wh / 2, y - wh, wh, wh);
        }
    };
    Game.prototype.cancelMove = function (slice) {
        var _this = this;
        var data = cloneData(this.data);
        var cellAnimations = slice.shadow.map(function (i) {
            data[i].value = 0;
            return _this.addCellAnimation(i);
        });
        this.data = data;
        this.needRedraw = true;
        this.toggleDragDrop(false);
        Promise.all(cellAnimations).then(function () {
            setTimeout(function () {
                slice.hidden = false;
                slice.shadow = undefined;
                slice.selected = false;
                slice.move = { x: 0, y: 0 };
                _this.toggleDragDrop(true);
                _this.saveSate();
                _this.needRedraw = true;
            }, 250);
        });
    };
    Game.prototype.selectSlice = function (slice) {
        slice.move.x -= this.sliceJumpX(slice);
        slice.move.y -= this.sliceJumpY(slice);
        slice.selected = true;
    };
    Game.prototype.getShadow = function () {
        var shadow = [];
        this.data.map(function (i, index) {
            if (i.shadow)
                shadow.push(index);
        });
        return shadow;
    };
    Game.prototype.stopMove = function () {
        unselect(this.slice);
        this.startPos = null;
        this.needRedraw = true;
        this.slice = null;
    };
    Game.prototype.updateSlices = function (force) {
        if ((this.slices[0].hidden && this.slices[1].hidden && this.slices[2].hidden) || force) {
            this.slices = randomSlices();
            alignSlices(this.slices);
        }
    };
    Game.prototype.isGameOver = function () {
        return FEATURES.USE_ROTATE ? checkLossWithRotate(this.slices, this.data) : checkLoss(this.slices, this.data);
    };
    Game.prototype.onGameOver = function (isRecord, isAbsoluteRecord) {
        var score = this.getScore();
        var _a = App.storage.get(), maxScore = _a.maxScore, countGamesToday = _a.countGamesToday;
        App.storage.upd({ countGamesToday: countGamesToday + 1 });
        if (isRecord) {
            App.storage.upd({ maxScore: Math.max(score, maxScore) });
            this.setMaxCounter(score);
        }
        playGameOverSound();
        this.emitter.emit('gameOver', {
            isRecord: isRecord && countGamesToday > 0,
            isAbsoluteRecord: isAbsoluteRecord,
            preview: drawPreview(this.data, this.slices, 0.25, isCancelMoveFeature()),
            score: score,
            rotateCounter: this.rotateCounter,
            historySize: this.history.length,
        });
    };
    Game.prototype.addScoreAnimations = function (e, countAdded, countDeleted) {
        var _this = this;
        var _a = App.storage.get(), learned = _a.learned, countGamesToday = _a.countGamesToday, comboAnimations = _a.comboAnimations;
        var _b = this.checkHighScore(), isRecord = _b[0], isAbsoluteRecord = _b[1];
        if (learned && isRecord && !this.isFirstGame && (isAbsoluteRecord || countGamesToday > 0)) {
            this.addConfettiEffect(function () { return _this.emitter.emit('HighScore', { absolute: isAbsoluteRecord, score: _this.getScore() }); });
            this.addHighScoreEffect(this.getScore(), isAbsoluteRecord);
            return;
        }
        if (countDeleted) {
            this.seriesCounter++;
            var x = Math.ceil(countDeleted / 9);
            var isCombo = x > 1;
            var isSeries = this.seriesCounter > 1;
            var deltaScore = countAdded + this.deleteScore(countDeleted);
            if (isCombo && isSeries && learned && comboAnimations) {
                this.addComboAnimation(t(PHRASES.Combo_x, [x]), deltaScore);
            }
            else if (isCombo && learned && comboAnimations) {
                this.addComboAnimation(t(PHRASES.Combo_x, [x]), deltaScore);
            }
            else if (isSeries && learned && comboAnimations) {
                this.addComboAnimation(t(PHRASES.Series_x, [this.seriesCounter]), deltaScore);
            }
            else {
                var _c = utils.eventPos(e), x_2 = _c.x, y = _c.y;
                this.addScoreAnimation("+".concat(deltaScore), x_2, y);
            }
        }
        else {
            if (countAdded)
                this.seriesCounter = 0;
        }
    };
    Game.prototype.checkHighScore = function () {
        var _a = App.storage.get(), maxScore = _a.maxScore, maxScoreToday = _a.maxScoreToday;
        var score = this.getScore();
        if (score > maxScore && !this.newTotalRecord) {
            this.newTotalRecord = true;
            this.newDailyRecord = true;
            return [true, true];
        }
        else if (score > maxScoreToday && !this.newDailyRecord) {
            this.newDailyRecord = true;
            return [true, false];
        }
        return [false, false];
    };
    Game.prototype.getScore = function () {
        return this.score + this.scoreBuffer;
    };
    Game.prototype.deleteScore = function (countDeleted) {
        return 2 * countDeleted + Math.max(2, this.seriesCounter) * 10;
    };
    Game.prototype.updateMovesHistory = function () {
        var score = this.getScore();
        this.history.push({ data: cloneData(this.data), slices: this.slices.map(cloneSlice), score: score });
        this.history = this.history.slice(-this.props.historySize);
    };
    Game.prototype.addScore = function (score) {
        var _this = this;
        if (score > 0) {
            this.scoreBuffer += score;
            App.storage.inc('totalScore', score);
        }
        if (this.scoreBuffer > 0) {
            var size = Math.ceil(this.scoreBuffer / 10);
            size = Math.min(size, this.scoreBuffer);
            this.scoreBuffer -= size;
            this.score += size;
            this.needRedraw = true;
            if (this.scoreBuffer > 0) {
                setTimeout(function () { return _this.addScore(0); }, 50);
            }
            else {
                var _a = App.storage.get(), maxScore_1 = _a.maxScore, maxScoreToday_1 = _a.maxScoreToday;
                maxScore_1 = Math.max(maxScore_1, this.score);
                maxScoreToday_1 = Math.max(maxScoreToday_1, this.score);
                setTimeout(function () { return App.storage.upd({ maxScore: maxScore_1, maxScoreToday: maxScoreToday_1, score: _this.score }); }, 1);
            }
        }
    };
    // ANIMATIONS
    Game.prototype.adTimerEffect = function (type) {
        var _a = App.settings.get(), nativeEffectTime = _a.nativeEffectTime, nativeEffectSpeed = _a.nativeEffectSpeed;
        var time = nativeEffectTime;
        var speed = nativeEffectSpeed / 100;
        if (type === 1) {
            var text = t(PHRASES.native_timer_text);
            this.afterEffects['ad'] = new effects.TimerEffect({ time: time, speed: speed, text: text /*, mask: 'rgba(49,46,43,0.25)'*/ });
        }
        else {
            this.afterEffects['ad'] = new effects.TimerEffect2({ time: time, speed: speed });
        }
    };
    Game.prototype.isTimerEffect = function () {
        return this.afterEffects['ad'] !== undefined && App.settings.get().uiDisabledOnNativeEffect;
    };
    Game.prototype.addConfettiEffect = function (onDone) {
        var _a = this.scene.size(), width = _a.width, height = _a.height;
        var opacity = this.isDarkTheme() ? '0.35' : '0.55';
        var bg = hexToRgba(App.themes.get().cell, opacity);
        if (height > 500)
            height = height - 150;
        this.afterEffects['confetti'] = new effects.ConfettiEffect({ width: width, height: height, bg: bg, onDone: onDone });
    };
    Game.prototype.addScoreAnimation = function (text, x, y, fontSize) {
        if (!fontSize) {
            fontSize = Math.floor(this.cellSize / 2);
            fontSize = Math.max(20, fontSize);
        }
        x = Math.max(this.gridPos.x + 50, x);
        x = Math.min(this.gridPos.x + this.cellSize * GRID_SIZE - 50, x);
        y = Math.max(this.gridPos.y + 50, y);
        y = Math.min(this.gridPos.y + this.cellSize * GRID_SIZE - 50, y);
        var shadowColor = this.isDarkTheme() ? '#003366' : '#0033CC';
        var color = '#FFFF00';
        this.afterEffects['score'] = new effects.TextEffect({ text: text, x: x, y: y, color: color, shadowColor: shadowColor, fontSize: fontSize, textDepth: 2 });
    };
    Game.prototype.isDarkTheme = function () {
        var theme = App.themes.get().name;
        return theme === 'night' || theme === 'green-lantern';
    };
    Game.prototype.addComboAnimation = function (text, deltaScore) {
        var _a = this.scene.size(), width = _a.width, height = _a.height;
        var x = Math.floor(width / 2);
        var y = Math.floor(height / 2);
        var fontSize1 = Math.ceil(this.cellSize * 0.7);
        var fontSize2 = Math.max(20, fontSize1 - 5);
        var y2 = y + fontSize1;
        var darkTheme = this.isDarkTheme();
        var color = darkTheme ? '#CCCC00' : '#FFFF00';
        var shadowColor = darkTheme ? '#99CCCC' : '#0033CC';
        var props = { color: color, shadowColor: shadowColor, textDepth: darkTheme ? 1 : 2 };
        this.afterEffects['combo'] = new effects.TextEffect(__assign({ text: text, x: x, y: y, fontSize: fontSize1 }, props));
        var text2 = "+".concat(deltaScore);
        this.afterEffects['score'] = new effects.TextEffect(__assign({ text: text2, x: x, y: y2, fontSize: fontSize2 }, props));
    };
    Game.prototype.addHighScoreEffect = function (score, absolute) {
        var _a = this.scene.size(), width = _a.width, height = _a.height;
        var x = Math.floor(width / 2);
        var y = Math.floor(height / 2);
        var fontSize = Math.ceil(this.cellSize * 0.5);
        var fontSize0 = fontSize * 2;
        var text1 = absolute ? t(PHRASES.HIGH_SCORE_1) : t(PHRASES.HIGH_SCORE_TODAY_1);
        var text2 = absolute ? t(PHRASES.HIGH_SCORE_2) : t(PHRASES.HIGH_SCORE_TODAY_2);
        var lineHeight = 1.4;
        var y0 = y - lineHeight * fontSize;
        var props = { text: '', x: x, y: y, fontSize: fontSize, vy: 0, az: 0.05, vf: 0.015, af: 10, color: '#fff' };
        this.afterEffects['h0'] = new effects.TextEffect(__assign(__assign({}, props), { text: "".concat(score), y: y0, fontSize: fontSize0 }));
        this.afterEffects['h1'] = new effects.TextEffect(__assign(__assign({}, props), { text: text1 }));
        if (text2)
            this.afterEffects['h2'] = new effects.TextEffect(__assign(__assign({}, props), { text: text2, y: y + lineHeight * fontSize }));
    };
    Game.prototype.addCellAnimation = function (index, delay) {
        if (delay === void 0) { delay = 0; }
        return this.addCellAnimationByProps(index, { delay: delay });
    };
    Game.prototype.addCellAnimationByProps = function (index, props) {
        var cell = utils.cellByIndex(index, 9);
        var pos = { x: cell[0] * this.cellSize + this.gridPos.x, y: cell[1] * this.cellSize + this.gridPos.y };
        return this.promisifyEffect(effects.CellEffect, __assign(__assign({}, pos), props));
    };
    return Game;
}(CanvasGame));
export { Game };
function updCurrentDate() {
    if (App.storage.get().currentDate !== today()) {
        App.storage.upd({ maxScoreToday: 0, countGamesToday: 0 /*, score: 0*/, currentDate: today() });
    }
}
function playGameOverSound() {
    App.sounds.playSound(5830);
    setTimeout(function () { return App.sounds.playSound(26447); }, 500);
    setTimeout(function () { return App.sounds.playSound(26447); }, 700);
    setTimeout(function () { return App.sounds.playSound(26447); }, 900);
}
function unselect(slice) {
    if (slice && !slice.hidden) {
        slice.move = { x: 0, y: 0 };
        slice.selected = false;
    }
}
